export interface Transaction {
    transactionDate: string
    transactionDescription: string
    debitAmount: number | null
    creditAmount: number | null
    referenceNo: string
    remarks: string
    transferRemarks: string
    accountType: 'CASA' | 'LOAN' | 'TD'
    accountNumber: string
    accountName: string
    runningBalance?: number | null
}

export interface TransactionHistoryResponse {
    transactions: Transaction[]
    totalCount: number
    hasMore: boolean
}

export interface TransactionHistoryRequest {
    clientId: string
    limit?: number
}

export const formatCurrency = (amount: number | null | undefined): string => {
    if (amount === null || amount === undefined) return ''
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'PHP',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(amount)
}

export const formatTransactionDate = (dateString: string): string => {
    const date = new Date(dateString)
    return new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    }).format(date)
}

export const getAccountTypeColor = (type: string): string => {
    switch (type) {
        case 'CASA':
            return 'primary'
        case 'LOAN':
            return 'warning'
        case 'TD':
            return 'success'
        default:
            return 'secondary'
    }
}

export const getAccountTypeLabel = (type: string): string => {
    switch (type) {
        case 'CASA':
            return 'Savings/Checking'
        case 'LOAN':
            return 'Loan'
        case 'TD':
            return 'Time Deposit'
        default:
            return type
    }
}